import styled from 'styled-components'

import { mainColors } from '../../styles/colors'
import { rgba } from '../../utils/cssUtils'

export const TriggerWrapper = styled.span`
  cursor: pointer;
  display: inline-flex;
  height: inherit;
  width: inherit;
`

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  border-radius: 2px;
  border: 1px solid ${mainColors.neutralMedium};
  background-color: ${mainColors.white};
  box-shadow: 0 4px 30px 0 ${rgba(mainColors.primaryDark, 0.15)};

  &:focus-visible {
    outline: 0;
  }
`
export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${mainColors.neutralExtremelyDark};
  padding: 12px 16px;
  border-radius: 2px 2px 0 0;
  background-color: ${mainColors.neutralExtraLight};
`

export const ContentWrapper = styled.div`
  padding: 12px 16px;
`
